<template>
    <div class="contain">
        <div class="contain-box">
            <div class="contain-left">
                <router-view v-if="isRouterAlive"></router-view>
            </div>
            <div class="contain-right" v-if="infos">
                <div class="contain-right-user">
                    <img :src="infos.avatar" alt="">
                    <div class="contain-right-user-msg">
                        <div class="contain-right-user-msg-name">{{infos.nickname}}</div>
                        <div class="contain-right-user-msg-id">ID：{{infos.id}}</div>
                    </div>
                </div>
                <!-- 标题 -->
                <div class="contain-right-title">我的社区</div>
                <!-- 关注 -->
                <div class="contain-right-follow" @click="goPage('/mine/my_community/my_attention')">
                    <div class="contain-right-follow-left">
                        <div>{{infos.follow_count}}</div>
                        <div>我的关注</div>
                    </div>
                    <div class="contain-right-follow-right">
                        <div class="follow-imgBox">
                            <img v-for="(item,index) in infos.follow" :key="index" class="follow-head" :src="item.be_user.avatar" alt="">
                        </div>
                        <img class="go" src="../../assets/image/goright.png" alt="">
                    </div>
                </div>
                <div class="contain-right-follow" @click="goPage('/mine/my_community/follow_my')">
                    <div class="contain-right-follow-left">
                        <div>{{infos.be_follow_count}}</div>
                        <div>关注我的</div>
                    </div>
                    <div class="contain-right-follow-right">
                        <div class="follow-imgBox">
                            <img v-for="(item,index) in infos.be_follow" :key="index" class="follow-head" :src="item.user.avatar" alt="">
                        </div>
                        <img class="go" src="../../assets/image/goright.png" alt="">
                    </div>
                </div>
                <!-- 评论 -->
                <div class="contain-right-other" @click="goPage('/mine/my_community/my_release')">
                    <div class="contain-right-other-left">
                        <div>我的发布</div>
                        <div>{{infos.post_num}}</div>
                    </div>
                    <div class="contain-right-other-right">
                        <img class="other-logo" src="../../assets/image/fabu.png" alt="">
                        <img class="go" src="../../assets/image/goright.png" alt="">
                    </div>
                </div>
                <div class="contain-right-other" @click="goPage('/mine/my_community/my_comments')">
                    <div class="contain-right-other-left">
                        <div>我的评论</div>
                        <div>{{infos.post_message_num}}</div>
                    </div>
                    <div class="contain-right-other-right">
                        <img class="other-logo" src="../../assets/image/pinglun.png" alt="">
                        <img class="go" src="../../assets/image/goright.png" alt="">
                    </div>
                </div>
                <div class="contain-right-other" @click="goPage('/mine/my_community/my_collection')">
                    <div class="contain-right-other-left">
                        <div>我的收藏</div>
                        <div>{{infos.post_collect_num}}</div>
                    </div>
                    <div class="contain-right-other-right">
                        <img class="other-logo" src="../../assets/image/shoucang.png" alt="">
                        <img class="go" src="../../assets/image/goright.png" alt="">
                    </div>
                </div>
                <!-- 发布按钮 -->
                <div class="contain-right-btn" @click="sendForum">
                    <img src="../../assets/image/add.png" alt="">
                    <div>我要发布</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import UploadList from '@/components/UploadList/index.vue'
import forumItem from '@/components/forum-item/index.vue'
import request from "@/utils/request";
import Cookies from 'js-cookie'
export default {
    components: {UploadList,forumItem},
    provide(){
        return{
            reload:this.reload
        }
    },
    data(){
        return{
            active:0,
            btnFlag:false,//返回顶部
            isRouterAlive:true,
            categoryList:[
                {
                    title:'默认'
                },
                {
                    title:'关注'
                },
                {
                    title:'推荐'
                },
                {
                    title:'热榜'
                },
            ],
            infos:null
        }
    },
    mounted () {
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
        window.removeEventListener('scroll', this.scrollToTop)
    },
    created(){
        console.log(this.$route.path,'this.$route.path')
        if(localStorage.getItem("userInfo")){
            this.info()
        }
    },
    methods:{
        reload(){
            this.isRouterAlive=false;
            this.$nextTick(function(){
                this.isRouterAlive=true
            })
        },
        goPage(url){
            this.$router.push(url)
        },
        info(){
            return request({
                url: '/api/userend/user/info',
                method: 'get',
                params: { }
            }).then(response =>{
                this.infos=response.data
                localStorage.setItem("userInfo",JSON.stringify(response.data))
                this.$store.commit("setUserInfo",JSON.parse(localStorage.getItem("userInfo")))
                // Cookies.set('userInfo', JSON.stringify(response.data), { expires: 15 })
                // this.$store.commit("setUserInfo",JSON.parse(Cookies.get('userInfo')))
            })
        },
        sendForum(){
            this.$router.push("/forum/sendForum")
        },
        clickTab(index){
            this.active=index;
        },
        backTop () {
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                    clearInterval(timer)
                }
            }, 16)
        },
        
        // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.btnFlag = true
            } else {
                that.btnFlag = false
            }
        }
    }
}
</script>
<style lang="scss">
    .contain-box{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .ispadding{
            padding: 20px 30px;
        }
        .contain-left{
            height: 100%;
            /* 这里给app一个滚动效果 */
            // overflow-y: scroll;
            width: 74%;
            background: #FFFFFF;
            border-radius: 8px;
            // padding: 20px 30px;
        }
        .contain-right{
            position: fixed;
            right: 0;
            width: 20%;
            height: 760px;
            background: #FFFFFF;
            border-radius: 8px;
            padding: 30px;
            .contain-right-user{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                // align-items: center;
                margin-bottom: 30px;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                }
                .contain-right-user-msg{
                    margin-left: 15px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .contain-right-user-name{
                        font-size: 20px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #1E2134;
                    }
                    .contain-right-user-id{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #506176;
                    }
                }
            }
            .contain-right-title{
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1E2134;
                margin-bottom: 15px;
            }
            .contain-right-follow{
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background: #F9FAFD;
                border-radius: 6px;
                padding: 13px 20px;
                margin-bottom: 20px;
                .contain-right-follow-left{
                    div{
                        &:nth-child(1){
                            font-size: 18px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                        }
                        &:nth-child(2){
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #858585;
                            margin-top: 4px;
                        }
                    }
                }
                .contain-right-follow-right{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    // padding-right: 40px;
                    .go{
                        width: 16px;
                        height: 16px;
                        margin-left: 10px;
                    }
                    .follow-imgBox{
                        // border: 1px solid #3D7EFF;
                        position: relative;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        .follow-head{
                            width: 35px;
                            height: 35px;
                            border-radius: 50%;
                            &:nth-child(1){
                                position: absolute;
                                right: 0;
                            }
                            &:nth-child(2){
                                position: absolute;
                                right: 20px;
                            }
                            &:nth-child(3){
                                position: absolute;
                                right: 40px;
                            }
                            &:nth-child(4){
                                position: absolute;
                                right: 60px;
                            }
                            &:nth-child(5){
                                position: absolute;
                                right: 80px;
                            }
                            &:nth-child(6){
                                position: absolute;
                                right: 100px;
                            }
                        }
                    }
                }
            }
            .contain-right-other{
                cursor: pointer;
                padding: 16px 20px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background: #F9FAFD;
                border-radius: 6px;
                margin-bottom: 20px;
                .contain-right-other-left{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    div{
                        &:nth-child(1){
                            font-size: 20px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #858585;
                        }
                        &:nth-child(2){
                            font-size: 20px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                            margin-left: 15px;
                        }
                    }
                }
                .contain-right-other-right{
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    .other-logo{
                        width: 45px;
                        height: 45px;
                        border-radius: 50%;
                    }
                    .go{
                        width: 16px;
                        height: 16px;
                        margin-left: 10px;
                    }
                }
            }
            .contain-right-btn{
                cursor: pointer;
                margin-top: 135px;
                height: 50px;
                background: #3D7EFF;
                border-radius: 6px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                img{
                    width: 20px;
                    height: 20px;
                }
                div{
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    margin-left: 6px;
                }
            }
        }
    }
</style>